import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPPlanetaryPosition ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Planetary Position');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetarypositionchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Planetary Position</h5></caption>
          <thead>
            <tr class="p-0">
              <th class="p-0 kptable-td">Planet</th> 
              <th class="p-0 kptable-td">Sign Lord</th> 
              <th class="p-0 kptable-td">Star Lord</th> 
              <th class="p-0 kptable-td">Sub Lord</th> 
              <th class="p-0 kptable-td">Sub Sub Lord</th> 
              <th class="p-0 kptable-td">SSS Lord</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">Sign</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">House</th> 
              <th class="p-0 kptable-td d-none d-md-table-cell">Star</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0" onClick={handleClickColor}>
                    <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[6].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[9].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[10].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[11].substring(0,3)}</td>
                    <td class="bg-transparent text-center p-0 kptable-td">{planet[12].substring(0,3)}</td>
                    <td class="bg-transparent text-start p-0 ps-1 kptable-td d-none d-md-table-cell">{planet[5]}</td>
                    <td class="bg-transparent text-center p-0 kptable-td d-none d-md-table-cell">{planet[3]}</td>
                    <td class="bg-transparent text-start p-0 ps-1  kptable-td d-none d-md-table-cell">{planet[7]}</td>
                </tr>
            ))
          }
            </tbody>  
          </table>
          )
        }
        </>
      );
  }